// Generated by ReScript, PLEASE EDIT WITH CARE


let dayInSeconds = 86400;

let weekInSeconds = 7 * dayInSeconds | 0;

let monthInSeconds = 31 * dayInSeconds | 0;

let hourInMilliseconds = 3600000;

let dayInMilliseconds = dayInSeconds * 1000 | 0;

let weekInMilliseconds = weekInSeconds * 1000 | 0;

let monthInMilliseconds = monthInSeconds * 1000.0;

function toIsoDateString(date) {
  return date.toISOString().substring(0, 10);
}

let dateIsoRe = /^\d{4,4}-\d{2,2}-\d{2,2}$/;

function fromIsoDateString(isoDateString) {
  if (dateIsoRe.test(isoDateString)) {
    return new Date(isoDateString + `T00:00`);
  }
  throw {
    RE_EXN_ID: "Invalid_argument",
    _1: "fromIsoDateString",
    Error: new Error()
  };
}

function compare(a, b) {
  return a.getTime() - b.getTime();
}

let hourInSeconds = 3600;

export {
  hourInSeconds,
  dayInSeconds,
  weekInSeconds,
  monthInSeconds,
  hourInMilliseconds,
  dayInMilliseconds,
  weekInMilliseconds,
  monthInMilliseconds,
  toIsoDateString,
  dateIsoRe,
  fromIsoDateString,
  compare,
}
/* No side effect */
